import { render, staticRenderFns } from "./TreeviewsSettings.vue?vue&type=template&id=36153508&"
import script from "./TreeviewsSettings.vue?vue&type=script&lang=js&"
export * from "./TreeviewsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports